module.exports = __webpack_public_path__ + "static/media/Susan's Samosas Market Menu.37f3a543.pdf";